<template>
  <div class="holdRuleGroupDelete">
    <b-card class="mb-4">
      <b-row>
        <b-col cols="12">
          <b-card-title>Definitief verwijderen</b-card-title>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card-text>
            Weet u zeker dat u de volledige groep wil verwijderen?
            Deze actie kan niet ongedaan worden gemaakt.
            Wellicht wil u de groep eerst op inactief zetten.
          </b-card-text>
          <b-button-group>
            <b-button @click="cancelDelete" variant="secondary">
              <i class="fas fa-times" />
              Annuleren
            </b-button>
            <b-button @click="confirmDelete" variant="danger">
              <i class="fas fa-trash" />
              Definitief verwijderen
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";

export default {
  name: "HoldRuleGroupDelete",

  props: {
    groupIdentifier: {
      type: String,
      required: true,
    },
    groupData: {
      type: Object,
      required: false,
    },
  },

  components: {
    PageTitle,
  },

  data() {
    return {};
  },

  methods: {
    cancelDelete() {
      this.$router.push({ name: 'holdRuleGroupEdit', params: this.$route.params });
    },
    confirmDelete() {
      const apiPath = `/api/rest/hold-rule-groups/${this.groupIdentifier}`;

      this.$http.delete(apiPath)
        .then((response) => {
          this.$alert("De groep is verwijderd", "success", true);
          this.$router.push({ name: 'holdRuleGroups' });
        })
        .catch((e) => {
          this.$alert(
            "Er is iets misgegaan bij het verwijderen van de groep",
            "danger",
            true
          );
          console.log(e);
        })
        .then(() => {
        });
    },
  },

  computed: {
    /**
     * Returns the page title
     * @returns {string} Page title
     */
    pageTitle() {
      return `Hold Order Group`;
    },
  },
};
</script>